import { useContext } from 'react';

//@ts-ignore
import { Context as UserAuthContext } from 'ui_auth/App';

function useUserAuth() {
  const { userAuth, isLoggedIn } = useContext(UserAuthContext);
  userAuth.isLoggedIn = isLoggedIn;
  return userAuth;
}

export default useUserAuth;
